/**
 * @file 钱包相关api
 */
import { get, post, WalletType } from '@web3/base-utils';
import {
  getChartDataParams,
  getChartDataRes,
  getDefiDataRes,
  getNftDataParams,
  getNftDataRes,
  NftBalance,
  SwapChain,
  WalletChainBalance,
} from '@/types/wallet';

export type QueryBalanceListParams = {
  type: WalletType;
  walletId: string;
  addressChain: Array<{ address: string; chainId: string }>;
};

export type WalletBalance = {
  totalAmountUsd: string;
  addressDetail: WalletChainBalance[];
};

export const getChartData = (params: getChartDataParams) => {
  return get<getChartDataRes>(
    `/web3/wallet/v1/private/mgmt/asset/chart`,
    params
  );
};

export const queryBalanceList = (params: QueryBalanceListParams) => {
  return post<WalletBalance>('/web3/wallet/v1/private/mgmt/asset/batchQuery', {
    ...(params || {}),
    autoFindAsset: 1,
  });
};

export const getDefiData = (chainCode: string) => {
  return get<getDefiDataRes>(`/spot/api/web3/staking/v2/account/all`, {
    chainCode,
  });
};

export const getInscriptionData = (address: string) => {
  return post<getDefiDataRes>(
    `/spot/api/web3/content/inscribe/personal/asset`,
    { chainId: 999999999, limit: 80, address }
  );
};

export const getNftData = (query: getNftDataParams) => {
  return get<getNftDataRes>(`/spot/api/nft/dex/v1/nft/wallet/asset`, query);
};

/** NFT资产列表 */
export const getNftList = (params: {
  walletAddress: string;
  chainCode: string;
  fromId?: string;
  direct?: string;
  size?: string;
}) => {
  return get<NftBalance[]>('/spot/api/web3/wallet/nftList', params);
};

/** 获取NFT资产列表 */
export const getOpenNftList = (params: {
  walletAddress: string;
  chainCode?: string;
  fromId?: string;
  direct?: string;
  size?: string;
}) => {
  return get<NftBalance[]>('/spot/api/web3/wallet/open/v1/nftList', params);
};

// 獲取swap支援的chains
export const getDexProSupportedChains = () => {
  return get<SwapChain[]>('/spot/api/web3/swap/v3/chains');
};
